interface SequenceOptions {
  total: number;      // Общее количество элементов
  current: number;    // Текущее активное число
  maxVisible: number; // Максимальное количество видимых элементов
}

export const generateSequence = ({ total, current, maxVisible }: SequenceOptions): number[] => {
  if (total <= 0 || current <= 0 || maxVisible <= 0) {
    return [];
  }

  // Всегда включаем первый и последний элементы
  const result: number[] = [1];
  
  // Вычисляем количество элементов для середины
  const middleCount = maxVisible - 2; // -2 для первого и последнего элементов
  
  if (middleCount <= 0) {
    return [1, total];
  }

  // Вычисляем диапазон для середины
  const halfMiddle = Math.floor(middleCount / 2);
  
  let start = Math.max(2, current - halfMiddle);
  const end = Math.min(total - 1, start + middleCount - 1);
  
  // Корректируем начальную точку, если достигли конца
  if (end === total - 1) {
    start = Math.max(2, end - middleCount + 1);
  }

  // Добавляем элементы середины
  for (let i = start; i <= end; i++) {
    result.push(i);
  }

  // Добавляем последний элемент, если он не равен первому
  if (total > 1) {
    result.push(total);
  }

  return result;
}; 